var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_vm._m(0),_vm._l((_vm.assistBtns),function(btn){return _c('el-button',{key:btn.id,staticClass:"content-operate",attrs:{"size":"small"},on:{"click":function($event){return _vm.openDownloadList(btn.id)}}},[_vm._v(_vm._s(btn.value)+" ")])})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-text"},[_c('h3',{staticClass:"content-title"},[_vm._v("辅助设计")])])
}]

export { render, staticRenderFns }